import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AgreementInstanceDTOBase } from "./AgreementInstanceDTOBase";
import type { AgreementRef } from "./AgreementRef";
import type { AgreementStaff } from "./AgreementStaff";

export class AgreementInstanceStaff implements AgreementInstanceDTOBase {
  constructor(public readonly assignId: number, public readonly startActive: Date | null, public readonly endActive: Date | null, public readonly agreementVersion: number | null, public readonly agreementText: string | null, public readonly agreementHeader: string | null, public readonly agreementAgreeText: string | null, public readonly agreementId: AgreementStaff | null, public readonly agreementIdTargetIds: AgreementRef) {
    this.cbiServiceContext = null;
    this.agreementIdLoaded = this.agreementId != null;
    this.agreementIdCached = this.agreementId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private agreementIdLoaded: boolean;
  private agreementIdCached: AgreementStaff | null;
  async agreementIdLazy(): Promise<AgreementStaff> {
    if (!this.agreementIdLoaded) {
      this.agreementIdCached = await this.cbiServiceContext!.catalogService().getAgreementStaff(this.agreementIdTargetIds.assignId);
      this.agreementIdLoaded = true;
    }
    return this.agreementIdCached!;
  }
}
